import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import { typography } from '@core/Typography2';
import generateEmotionClasses from '@core/utils/generateEmotionClasses';

import type { Props as TabProps } from './Tab';

export const classes = generateEmotionClasses('tab', [
  'focusVisible',
  'wrapper',
  'selected',
]);

const variants = {
  primary: css`
    margin-right: var(--cds-spacing-300);
  `,

  section: css`
    margin-right: var(--cds-spacing-200);
  `,
};

export default (props: TabProps) => css`
  opacity: 1;
  min-height: 48px;
  min-width: 44px;
  max-width: none;
  overflow: visible;
  text-align: left;
  text-transform: none;
  align-self: flex-end;
  padding: var(--cds-spacing-150) 0;
  color: var(--cds-color-interactive-secondary-inactive);

  ${typography.bodyPrimary};
  ${variants[props.variant as NonNullable<TabProps['variant']>]};

  &:focus {
    outline: none;
  }

  &:hover {
    border-radius: var(--cds-border-radius-50);
    text-decoration: none;
    color: var(--cds-color-interactive-secondary-hover);

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: var(--cds-spacing-50);
      border-radius: var(--cds-border-radius-25) var(--cds-border-radius-25) 0 0;
      background-color: var(--cds-color-neutral-stroke-primary-weak);
    }
  }

  &.${classes.selected} {
    color: var(--cds-color-interactive-secondary);
    ${typography.actionPrimary};
  }

  &.${classes.focusVisible} {
    flip: false;
    border: none;
    border-radius: var(--cds-border-radius-100);
    color: var(--cds-color-interactive-secondary-hover);
    outline: solid 1px var(--cds-color-interactive-stroke-primary-focus);
    outline-offset: 2px;
  }

  .${classes.wrapper} {
    flex-direction: row;

    & > *:first-of-type {
      min-width: 20px;
      margin: 0 var(--cds-spacing-50) 0 0;
    }
  }

  ${breakpoints.down('xs')} {
    max-width: 160px;
  }

  @media (forced-colors: active) {
    &.${classes.focusVisible} {
      text-decoration: underline;
    }
  }
`;
